export const EMPTY_CROP = { name: "", area_dekar: "", notes: "" };
export const HARVEST_UNIT_OPTIONS = ["ton", "kg", "balya"];
export function today() { return new Date().toISOString().slice(0, 10); }
export function fmt(v) { return Number(v || 0).toLocaleString("tr-TR"); }
